import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TPropertyId } from 'stores/fieldAssetStore/helperTypes'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const propertyIsSouthernHemisphere = (
  propertyId: TPropertyId = Number(selectedFieldAssetsStore.getState().property),
) => {
  try {
    return fieldAssetStore.getState()?.properties?.[propertyId]?.isSouthernHemisphere
  } catch (err) {
    // TODO: errorLogger
    return false
  }
}
